import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#3373dc', // blue
    mutedprimary: '#0259a1', // blue
    secondary: '#fff', // white
    faded: '#efefef', // light grey
    fadegrey: '#212121', // darker fadegrey
    accent: '#73ba20', // green
    error: '#F23350', // red
    warning: '#f5c32e', // yellow
    info: '#626262', // grey
    success: '#7fc52e', // green
    totalsbutton: '#1c4680' // green
  }
})
